var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-preview-container"},[_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"media-preview-item",class:{
      selected: _vm.isSelected(item),
      'current-selected': _vm.isCurrent(item),
    },on:{"click":function($event){return _vm.onItemClick(item)}}},[_c('MediaPreview',{attrs:{"item":item}})],1)}),(!_vm.items.length)?_c('div',{staticClass:"text-muted w-100 text-center py-4"},[_vm._v(" No hay archivos para mostrar. ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }